import { action as apiAction } from 'api/Api'
import {
  setStatus as setCardStatus,
} from 'routes/Board/redux/cards'
import sweetalert from 'sweetalert2'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  boardId?: number
  cardId: number
  statusId: number
}

const requestMoveCard = (payload: Payload) => async (dispatch, getState) => {
  const { boardId, cardId, statusId } = payload

  const state = getState()

  if (!boardId || state['view-board'].cards[cardId].boardId === boardId) { // Same board
    const optimisticAction = optimisticDispatch(dispatch, setCardStatus({
      id: cardId,
      statusId,
    }))

    try {
      await apiAction('SetCardStatus', {
        cardId,
        cardStatusId: statusId,
        position: 'top',
      })

      optimisticAction.commit()
    } catch (error) {
      optimisticAction.revert()

      if (error.code === 539) { // Card is blocked
        try {
          await sweetalert({
            text: getState().kanbo.locale.messages['BLOCKERS_CARD_BLOCKED_ERROR'],
            type: 'info'
          })
        } catch (e) {}
      } else if (error.code !== 302) { // Source and target are the same
        throw error
      }
    }
  } else { // Other board
    sweetalert({
      type: 'info',
      text: state.kanbo.locale.messages['CARD_MOVE_IN_PROGRESS'],
      showConfirmButton: false,
      allowOutsideClick: false
    }).catch(sweetalert.noop)

    try {
      await apiAction('MoveCard', {
        targetStatusId: statusId,
        cardId,
        position: 'top',
        allowFilesRemove: true,
        copyFiles: true
      })

      sweetalert.close()
    } catch (error) {
      sweetalert.close()

      if (error.code === 539) { // Card is blocked
        try {
          await sweetalert({
            text: getState().kanbo.locale.messages['BLOCKERS_CARD_BLOCKED_ERROR'],
            type: 'info'
          })
        } catch (e) {}
      } else {
        throw error
      }
    }
  }
}

export default requestMoveCard
